<app-page-header [heading]="'Customer'" [icon]="'fa-user'" style="height:100px;"></app-page-header>

<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="row col-lg-12">
    <div class="form-group col-lg-3">
      <label>Code</label><span class="text-danger">&nbsp;*</span>
      <input [(ngModel)]="customer_data.customer_code" class="form-control " maxlength="15"
             name="customer_code" readonly type="text">
    </div>
    <div class="form-group col-lg-3">
      <label>Name</label><span class="text-danger">&nbsp;*</span>
      <input [(ngModel)]="customer_data.customer_name" class="form-control " maxlength="100" name="name"
             type="text">
    </div>
    <div class="form-group col-lg-3">
      <label>Phone Number</label>
      <input [(ngModel)]="customer_data.customer_phoneno" class="form-control " maxlength="100"
             name="phone"
             type="text">
    </div>
    <div class="form-group col-lg-3">
      <label>Address</label>
      <textarea [(ngModel)]="customer_data.customer_address" class="form-control " maxlength="100"
                name="address"
                type="text"></textarea>
    </div>
    <div class="form-group col-lg-3">
      <label>VAT No</label>
      <input [(ngModel)]="customer_data.vat_no" class="form-control " maxlength="20" name="vat"
             type="text">
    </div>
    <div class="form-group col-lg-3">
      <label>Email</label>
      <input [(ngModel)]="customer_data.customer_email" class="form-control " id="" maxlength="50"
             name="email"
             type="text">
    </div>
  </div>
  <div class="clearfix"></div>
  <div class="row container">
    <div class="col-lg-7 pull-right">
      <button (click)="savecustomer();" *ngIf="user_rights.ADD == '1'" class="btn btn-info btn-sm ng-star-inserted"
              type="button">&nbsp;Save&nbsp;
      </button>&nbsp;&nbsp;&nbsp;
      <button (click)="clearcustomer();" *ngIf="user_rights.ADD == '1'" class="btn btn-danger btn-sm" type="button">
        &nbsp;Clear&nbsp;
      </button>
    </div>
  </div>
  <div class="clearfix"></div>
</div>

<div class="col-lg-12 page-break">
  <div class=" row">
    <div class="col-lg-8">
      <h4 class="list-header">Customer List</h4>
    </div>
    <div class="col-lg-4">
      <div class="input-group">
        <input (keydown)="keyDownFunction($event)" [(ngModel)]="customer_data.search_customer" class="form-control"
               id="typeahead-http"
               name="search_text" placeholder="Customer Name / Code / State ..." style="height:31px"
               type="text">
        <div class="input-group-append">
          <button (click)="clear_search()" class="input-group-text" style="height:31px;padding:7px">
            <i *ngIf="customer_data.search_customer != ''" class="fa fa-close"></i>
            <i *ngIf="customer_data.search_customer == ''" class="fa fa-search"></i>
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="this.status == 'Failed'"><span [hidden]="this.status == 'Success'"
                                               style="color:red;font-size:13px;"> Sorry, suggestions could not be loaded.</span>
    </div>
  </div>
  <div class="clearfix"></div>
  <div class="">
    <table class="table tbl  table-hover table-striped  table-bordered">
      <thead>
      <tr>
        <th width="1%">Sl#</th>
        <th width="9%">Code</th>
        <th width="20%">Name</th>
        <th width="10%">Phone number</th>
        <th width="15%">Address</th>
        <th width="7%">Action</th>
      </tr>
      <tr *ngIf="(customers_data | json) == '[]'">
        <td class="text-center" colspan="10">No data to list</td>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let data of customers_data;let i=index" style="font-size: 12px">
        <td>{{ start + i + 1 }}</td>
        <td>{{ data.CUSTOMER_CODE }}</td>
        <td>{{ data.CUSTOMER_NAME }}</td>
        <td>{{ data.CUSTOMER_PHONE }}</td>
        <td>{{ data.CUSTOMER_ADDRESS }}</td>
        <td>
          <button (click)="editcustomer(data);" *ngIf="user_rights.EDIT == '1'" alt="Edit" class="btn btn-sm btn-info"
                  style="font-size: 10px;" title="Edit"><i class="fa fa-edit"></i></button>
          &nbsp;&nbsp;
          <button (click)="deleteCustomer(data.CUSTOMER_ID);" *ngIf="user_rights.DELETE == '1'" alt="Delete"
              class="btn btn-sm btn-danger" style="font-size: 10px" title="Delete"><i class="fa fa-trash"></i></button>
        </td>
      </tr>
      </tbody>
    </table>
    <app-pagination (pageChange)="getcustomerList($event)" [pageSize]="p" [page]="page" [recordCount]="collection"/>
  </div>
</div>


